/* eslint-disable max-len */
import $ from 'jquery'
import random from 'toxilibs/random.js'

const shapes = [
    '<polygon class="star" points="21,0,28.053423027509677,11.29179606750063,40.97218684219823,14.510643118126104,32.412678195541844,24.70820393249937,33.34349029814194,37.989356881873896,21,33,8.656509701858067,37.989356881873896,9.587321804458158,24.70820393249937,1.0278131578017735,14.510643118126108,13.94657697249032,11.291796067500632"></polygon>',
    '<polygon class="other-star" points="18,0,22.242640687119284,13.757359312880714,36,18,22.242640687119284,22.242640687119284,18.000000000000004,36,13.757359312880716,22.242640687119284,0,18.000000000000004,13.757359312880714,13.757359312880716"></polygon>'
]

const colors = [
    '#10b4ab',
    '#10b4ab',
    '#10b4ab',
    '#ff8570',
    '#ffd147'
]



function addParticles ($element) {

    let group = []

    const $particlesContainer = $('<div class="particles">')
    $particlesContainer.insertAfter($element)

    $particlesContainer.css({
        right: ($element.width() / 2) + 'px'
    })


    const count = random.intBetween(30, 40)

    for (let i = 0; i < count; i++) {
        const fill     = random.pick(colors)
        const scale    = random.between(0.5, 1.2)

        let startX     = -10 - scale * 25
        let startY     =  15 - scale * 25

        const dx       = random.intBetween(-100, 100)
        const dy       = random.intBetween(-120, 0)
        const duration = random.intBetween(500, 1000)
        const shape    = $('<svg class="particle">' + random.pick(shapes) + '</svg>')

        shape.css({
            top:  startY,
            left: startX,
            transform: 'translate(0, 0) scale(' + scale + ')',
            transition: duration + 'ms',
            fill
        })


        $particlesContainer.append(shape)

        group.push({shape, dx, dy})
    }

    setTimeout(() => setStyle(group), 5)

    setTimeout(() => $particlesContainer.remove(), 1000)

}


// a transform, not left and top: no layout at every frame (modest phones)
function setStyle (group) {
    group.forEach(({dx, dy, shape}) => {
        shape.css({
            transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(0)'
        })
    })
}


export default addParticles


